// Import model
import { Fcb2BUnderlaymentOption } from '../models/Fcb2BUnderlaymentOption';

// Import base class serializer
import { EstimateOptionsSerializer } from './EstimateOptionsSerializer';

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for Fcb2BUnderlaymentOption - handles JSON serialization and deserialization with type validation
 */
export class Fcb2BUnderlaymentOptionSerializer {
  /**
   * Deserializes a JSON string into a Fcb2BUnderlaymentOption instance
   */
  static deserialize(json: string): Fcb2BUnderlaymentOption {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a Fcb2BUnderlaymentOption instance
   */
  static fromObject(obj: any): Fcb2BUnderlaymentOption {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to Fcb2BUnderlaymentOption');
    }


    const instance: Fcb2BUnderlaymentOption = {
      description: obj['description'] as string | undefined,
      externalId: obj['externalId'] as string | undefined,
      name: obj['name'] as string | undefined,
      id: obj['_id'] as string | undefined,
      type_: obj['type'] as string,
      productType: obj['productType'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of Fcb2BUnderlaymentOption instances
   */
  static deserializeArray(json: string): Fcb2BUnderlaymentOption[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a Fcb2BUnderlaymentOption instance to a JSON string
   */
  static serialize(instance: Fcb2BUnderlaymentOption): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a Fcb2BUnderlaymentOption instance to a plain object
   */
  static toObject(instance: Fcb2BUnderlaymentOption): any {
    return {
      'description': instance.description,
      'externalId': instance.externalId,
      'name': instance.name,
      '_id': instance.id,
      'type': instance.type_,
      'productType': instance.productType,
    };
  }

  /**
   * Serializes an array of Fcb2BUnderlaymentOption instances to a JSON string
   */
  static serializeArray(instances: Fcb2BUnderlaymentOption[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
